import React from 'react'

import { CircularProgress, Box, useTokens } from '@barracuda-internal/bds-core-v2'

export const Pending = () => {
  const tokens = useTokens()

  return (
    <Box
      sx={{
        flow: 'vertical',
        width: 'fixed',
        height: 'fill',
        maxWidth: '680px',
        radius: tokens.aliasesBorderRadiusDefault,
        padding: tokens.aliasesSpaceContainerSpacious,
        color: tokens.aliasesColorBgStaticComponentSubtle
      }}
    >
      <CircularProgress />
    </Box>
  )
}
